import store from "@/store";

/**
 * 
 * @param {string} type 
 * @param {object} to 
 * @param {object} from 
 * @returns {void}
 */
export const handleBreadcrumbs = (type, to, from) => {
    if ( type == 'beforeEach' ) return handleBreadcrumbsInBeforeEach(to, from)

    if ( type == 'afterEach' ) return handleBreadcrumbsInAfterEach(to)
}


/**
 * Se o usuário voltar ( back button ), remove a rota atual da lista de breadcrumbs.
 * @param {object} to 
 * @param {object} from 
 * @returns {void}
 */
const handleBreadcrumbsInBeforeEach = (to, from) => {

    const routesDetails = {
        from,
        to
    }

    store.dispatch("components/removeRouteFromBreadcrumbs", routesDetails)
}


/**
 * Adiciona a rota atual à lista de breadcrumbs.
 * @param {object} to 
 * @returns {void}
*/
const handleBreadcrumbsInAfterEach = (to) => {
    const { meta, name } = to;

    /* Sempre reseta os breadcrumbs ao entrar na rota dashboard ( home ) */
    if ( name == 'dashboard' || name == 'forum' ) {
        return store.dispatch("components/resetAllBreadcrumbs")
    }

    if ( !meta ) return;

    /*  Verifica se a rota atual tem um breadcrumb.  */
    const { breadcrumb } = meta;

    if ( !breadcrumb ) return;

    store.dispatch("components/addRouteToBreadcrumbs", breadcrumb)
}

